var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-lg shadow-lg p-2"},[_c('b-card',[_c('h3',[_vm._v("Add Exception")]),_c('form-component',{attrs:{"exception":_vm.exception}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }